module.exports = __webpack_public_path__ + "static/media/44458569_2199892153419297_623668515970220032_o.83adde8c.jpg";